import { __decorate, __metadata } from "tslib";
import { Component, Input } from '@angular/core';
var LoadingSpinnerComponent = /** @class */ (function () {
    function LoadingSpinnerComponent() {
    }
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], LoadingSpinnerComponent.prototype, "show", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], LoadingSpinnerComponent.prototype, "message", void 0);
    LoadingSpinnerComponent = __decorate([
        Component({
            selector: 'loading',
            templateUrl: 'app/components/loading/loading.html'
        }),
        __metadata("design:paramtypes", [])
    ], LoadingSpinnerComponent);
    return LoadingSpinnerComponent;
}());
export { LoadingSpinnerComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9hZGluZy5jb21wb25lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi93b3JrcGxhY2VMaXZpbmdTZXJ2aWNlcy9zcmMvYXBwL2NvbXBvbmVudHMvbG9hZGluZy9sb2FkaW5nLmNvbXBvbmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFDLFNBQVMsRUFBRSxLQUFLLEVBQUMsTUFBTSxlQUFlLENBQUM7QUFNL0M7SUFLRTtJQUNBLENBQUM7SUFKUTtRQUFSLEtBQUssRUFBRTs7eURBQWE7SUFDWjtRQUFSLEtBQUssRUFBRTs7NERBQWdCO0lBSGIsdUJBQXVCO1FBSm5DLFNBQVMsQ0FBQztZQUNULFFBQVEsRUFBRSxTQUFTO1lBQ25CLFdBQVcsRUFBRSxxQ0FBcUM7U0FDbkQsQ0FBQzs7T0FDVyx1QkFBdUIsQ0FPbkM7SUFBRCw4QkFBQztDQUFBLEFBUEQsSUFPQztTQVBZLHVCQUF1QiJ9